import React from 'react';
import { useSelector } from 'react-redux';
import { Spinner } from 'reactstrap';
import { checkMot } from '../../ressources/functionJS/checkMot';
import S from './AttenteRequete.module.scss';

const AttenteRequete = ({ request_type, str, children }) => {
  // Use useSelector hook to get state from Redux
  const attenteReq = useSelector(
    (state) => state.attenteRequete['ATTENTE_REQUETE' + request_type]
  );

  // Early return pattern for better readability
  if (attenteReq === undefined || !attenteReq) {
    return children;
  }

  return (
    <>
      <Spinner className={S.spinner}>
        {str || checkMot('requete_en_cours')}
      </Spinner>
    </>
  );
};

export default AttenteRequete;
